import React from "react";
import styled from "styled-components";
import { ArrowPointUp, ArrowPointDown } from "@conserveit/blocks";
import { Direction } from "../../utils/columns";

const shared = `
  margin: 0 4px;
`;

const StyledArrowPointUp = styled(ArrowPointUp)`
  ${shared};
`;

const StyledArrowPointDown = styled(ArrowPointDown)`
  ${shared};
`;

const SortArrow: React.FC<{ direction: Direction }> = ({
  direction = "desc",
}) => {
  if (direction === "asc") {
    return <StyledArrowPointUp tiny />;
  }
  return <StyledArrowPointDown tiny />;
};

export default SortArrow;
